import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";

/**
 * Hero header aligned with coach-console PageHeader: primary gradient, white copy.
 */
function DashboardPageHeader({ title, subtitle, icon, action }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        color: theme.palette.primary.contrastText,
        py: { xs: 2, sm: 2.5 },
        px: { xs: 2, sm: 3 },
        borderRadius: { xs: 0, sm: 2 },
        mb: { xs: 2, sm: 3 },
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={2} alignItems="center" sx={{ flexWrap: { xs: "wrap", sm: "nowrap" }, minWidth: 0 }}>
          {icon ? (
            <Box
              sx={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "inherit",
                "& .MuiSvgIcon-root": { color: "inherit", fontSize: { xs: 36, sm: 40 } },
              }}
              aria-hidden
            >
              {icon}
            </Box>
          ) : null}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                color: "inherit",
                fontSize: { xs: "1.35rem", sm: "1.75rem" },
                fontWeight: 700,
                lineHeight: { xs: 1.35, sm: 1.25 },
                wordBreak: "break-word",
                mb: subtitle ? 0.5 : 0,
              }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography
                variant="subtitle1"
                sx={{
                  color: "inherit",
                  opacity: 0.92,
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                  lineHeight: 1.45,
                  wordBreak: "break-word",
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Stack>
        {action ? (
          <Box sx={{ flexShrink: 0, alignSelf: { xs: "stretch", sm: "center" } }}>{action}</Box>
        ) : null}
      </Stack>
    </Box>
  );
}

export default DashboardPageHeader;
